import { Search } from "@mui/icons-material";
import { Box, InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { tags } from "../../assets/dummyData";
import { motion, AnimatePresence } from "framer-motion";

const SearchBar = ({ search, setSearch }) => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [typedText, setTypedText] = useState("");
  const [showText, setShowText] = useState(true);

  // Controls typing and exit cycle
  useEffect(() => {
    const currentTag = tags[index].name;
    setTypedText("");
    setShowText(true);

    let charIndex = 0;
    const typingInterval = setInterval(() => {
      setTypedText(currentTag.slice(0, charIndex + 1));
      charIndex++;
      if (charIndex === currentTag.length) {
        clearInterval(typingInterval);
        // Wait 1s after typing complete, then hide for exit animation
        setTimeout(() => setShowText(false), 1000);
      }
    }, 100); // typing speed per character

    return () => clearInterval(typingInterval);
  }, [index]);

  // Move to next tag after exit animation
  useEffect(() => {
    if (!showText) {
      const timeout = setTimeout(() => {
        setIndex((prev) => (prev + 1) % tags.length);
      }, 500); // exit animation duration
      return () => clearTimeout(timeout);
    }
  }, [showText]);

  const handleSearch = () => {
    if (search.trim().length > 0) {
      navigate("/search", { state: { search } });
    }
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <TextField
        variant="outlined"
        placeholder=""
        value={search}
        autoComplete="off"
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        sx={{
          mb: 1,
          "& .MuiOutlinedInput-root": {
            borderRadius: "27px",
            height: "40px",
            backgroundColor: "#fff",
            "& input": { paddingLeft: "16px" },
            "& fieldset": { borderColor: "#FFB79C" },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFB79C !important",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFB79C",
            },
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              onClick={() => navigate("/search", { state: { search } })}
              style={{ cursor: "pointer" }}
            >
              <Search sx={{ color: "#e1e1e1" }} />
            </InputAdornment>
          ),
        }}
        fullWidth
      />

      {!search && (
        <Box
          sx={{
            position: "absolute",
            left: "16px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "#9e9e9e",
            pointerEvents: "none",
            overflow: "hidden",
            height: "1.9em",
          }}
        >
          <AnimatePresence mode="wait">
            {showText && (
              <motion.span
                key={index}
                initial={{ y: "100%", opacity: 0 }}
                animate={{ y: "0%", opacity: 1 }}
                exit={{ y: "-100%", opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{
                  display: "block",
                  whiteSpace: "nowrap",
                  fontSize: "0.9rem",
                }}
              >
                {typedText}
                <motion.span
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ repeat: Infinity, duration: 1 }}
                  style={{ display: "inline-block" }}
                >
                  |
                </motion.span>
              </motion.span>
            )}
          </AnimatePresence>
        </Box>
      )}
    </Box>
  );
};

export default SearchBar;
